export type Direction = 'top' | 'right' | 'bottom' | 'left';

export type ArrowDirection = 'up' | 'down' | 'left' | 'right';
